import usePageTitle from "@ch/helpers/hooks/usePageTitle";
import type { FC } from "react";
import { useRouteError } from "react-router-dom";

interface TError {
  statusText?: string;
  message?: string;
}

const ErrorPage: FC = () => {
  usePageTitle("An error occurred");

  const error = useRouteError() as TError;

  return (
    <div className="flex h-full w-full items-center justify-center">
      <div className="text-center">
        <h1>Oops!</h1>
        <div>
          <p>Sorry, an unexpected error has occurred.</p>
          <p>
            <i>{error?.statusText ?? error?.message}</i>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;
